import { REACT_APP_READER_URL } from 'env'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { reportError } from 'utils/error'
import { useState } from 'react'

export const useConfirm = () => {
  const context = useImagePickerContext()
  const { selectedImages, setSelectedImages, onConfirm, uploadImages } = context
  const [isConfirming, setIsConfirming] = useState(false)

  const confirm = async () => {
    const image = selectedImages[0]
    if (!image) return

    if (context.onBeforeConfirm) {
      const confirmed = await context.onBeforeConfirm(selectedImages)
      if (!confirmed) {
        return
      }
    }

    setIsConfirming(true)
    try {
      let url = image.url
      if (url.startsWith('http')) {
        url = `${REACT_APP_READER_URL}/proxy/image?url=${encodeURIComponent(url)}`
      }
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error()
      }
      const blob = await response.blob()
      const file = new File([blob], image.original_filename || 'filename', { type: blob.type })

      const uploadedImages = await uploadImages([file], context)
      setSelectedImages(uploadedImages)
      onConfirm(uploadedImages, context)
    } catch (error) {
      reportError(error)
      showToastMessage('An error occurred', 'error')
    } finally {
      setIsConfirming(false)
    }
  }

  return { confirm, isConfirming }
}
